module.exports = __webpack_public_path__ + "static/media/160.76-EG1.0356a386.pdf";